import React from 'react';
import Divider from 'src/components/10-atoms/Divider';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import GQLPaginatedList from 'src/lib/graphql/components/GQLPaginatedList';
import { renderNamedSlot } from 'src/utils/component';
import styleUtils from 'src/utils/styles';
import QuestionItem from './QuestionItem';
import QuestionListEmpty from './QuestionListEmpty';
import QuestionListLoader from './QuestionListLoader';
import QuestionSearchLoader from './QuestionSearchLoader';
function QuestionListItems({ variant, ListEmptyComponent, isMasterDetail, selectedQuestionID, onItemPress, getQuestionTo, queryState, ...paginatedListProps }) {
    const [{ theme }] = useTheme();
    const listLoader = variant === 'question-search' ? (React.createElement(QuestionSearchLoader, null)) : (React.createElement(QuestionListLoader, { style: styleUtils.spaceBtwHeadNBody }));
    return (React.createElement(GQLPaginatedList, { LoaderComponent: listLoader, NextLoaderComponent: QuestionListLoader, ListEmptyComponent: ListEmptyComponent ? (renderNamedSlot(ListEmptyComponent)) : (React.createElement(QuestionListEmpty, { variant: variant })), renderItem: ({ item, index }) => {
            const selected = isMasterDetail && selectedQuestionID === item.id;
            return (React.createElement(QuestionItem, { variant: variant, data: item, bg: selected ? theme.palette.primary.subtle : undefined, to: isMasterDetail ? undefined : getQuestionTo?.(item, index), onPress: isMasterDetail
                    ? () => onItemPress?.(item, index)
                    : onItemPress
                        ? () => onItemPress(item, index)
                        : undefined }));
        }, ItemSeparatorComponent: Divider, containerStyle: styleUtils.flex, queryState: queryState, ...paginatedListProps }));
}
export default QuestionListItems;
